import React from "react";
import Layout from "../Layout";
import { useTranslation } from "react-i18next";
import { Code, Search, Wallet, Palette } from "lucide-react";
import imageService from "../../../assets/Selection.png";
import { motion } from "framer-motion";

function ServicesPage() {
  const { t } = useTranslation();

  const services = [
    {
      icon: <Code className=" text-MainBlue  w-6 h-6" />,
      title: t("services.webDevelopmentTitle"),
      desc: t("services.webDevelopmentDesc"),
    },
    {
      icon: <Search className="text-MainBlue w-6 h-6" />,
      title: t("services.seoTitle"),
      desc: t("services.seoDesc"),
    },
    {
      icon: <Wallet className="text-MainBlue w-6 h-6" />,
      title: t("services.paymentLinkTitle"),
      desc: t("services.paymentLinkDesc"),
    },
    {
      icon: <Palette className="text-MainBlue w-6 h-6" />,
      title: t("services.graphicDesignTitle"),
      desc: t("services.graphicDesignDesc"),
    },
  ];
  const ServiceItem = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <Layout title={t("pages.services")}>
      {/* Section Header */}
      <section className="bg-muted py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-MainBlue mb-4">
              {t("services.ourServices")}
            </h2>
            <p className="text-lg text-muted-foreground">
              {t("services.ourServicesDesc")}
            </p>
          </div>
          <div>
            <img src={imageService} alt="Our Services" className="w-full" />
          </div>
        </div>
      </section>

      {/* Core Services */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-12">
            {t("services.coreServices")}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {services.map((s, i) => (
              <motion.div
                key={i}
                variants={ServiceItem}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                className="p-6 justify-start text-start border rounded-xl shadow-sm flex items-start gap-4  hover:shadow-md transition"
              >
                <div className="">{s.icon}</div>
                <div>
                  <h4 className="text-lg font-semibold text-MainBlue">
                    {s.title}
                  </h4>
                  <p className=" mt-1">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default ServicesPage;
